/**
 * Created by neo on 22.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useState } from 'react';
import styled from '@emotion/styled';
import { useRootStore } from '../../Store/useRootStore';
import { useNavigate } from 'react-router-dom';
import { Theme } from '../../Theme/Theme';
import { getMediaSmallest } from '../../Model/Media/Media';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const ProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid transparent;
  transition: all 0.15s ease;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background-color: ${Theme.Colors.lightestGrey};
  }

  &:hover img {
    border-color: ${Theme.Colors.primary};
  }

  i {
    font-size: 28px;
    color: ${Theme.Colors.textColor};
    transition: color 0.15s ease;
  }

  &:hover i {
    color: ${Theme.Colors.primary};
  }
`;

export type HeaderProfileMenuProps = {};

export const HeaderProfileMenu: React.FC<HeaderProfileMenuProps> = observer((props) => {
  const { authentication } = useRootStore();

  const navigate = useNavigate();

  const [mouseOver, setMouseOver] = useState(false);
  const [clicked, setClicked] = useState(false);

  const profileSource = authentication.athlete?.profilePicture ? getMediaSmallest(authentication.athlete.profilePicture) : undefined;

  const handleToggle = React.useCallback(() => {
    navigate('/account');
    setClicked((p) => !p);
  }, [navigate]);

  const handleMouseOver = React.useCallback(() => setMouseOver(true), []);

  const handleMouseOut = React.useCallback(() => setMouseOver(false), []);

  return (
    <Container>
      <ImageContainer onClick={handleToggle} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
        {profileSource ? (
          <ProfileImage src={profileSource} />
        ) : (
          <i className="bi bi-person-circle" style={{ fontSize: 32 }}></i>
        )}
      </ImageContainer>
    </Container>
  );
});
